import React from 'react';
import { TypeAnimation } from 'react-type-animation';
import './styles.css';

const VideoBanner: React.FC = () => (
  <div className="video_backdrop">
    <video
      src="/video/intro.mp4"
      autoPlay
      controls={false}
      muted
      style={{ width: '100%' }}
      loop
    />

    <div className="overflow_text">
      <p>
        <TypeAnimation
          sequence={[
            "Embark on a journey to uncover\nThe enchanting allure of Sri Lanka's hidden gems",
          ]}
          wrapper="span"
          speed={30}
          style={{ whiteSpace: 'pre-line' }}
        />
      </p>
    </div>
  </div>
);

export default VideoBanner;
